import React, { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import { AuthProvider } from "./context/AuthContext";
import { StripeProvider } from "./context/StripeContext";
import { PaymentProviderProvider } from "./context/PaymentProviderContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./landingPage/home";
import Privacypage from "./landingPage/PrivacyPage";
import Terms from "./landingPage/TermsandCondition";
import UserPolicy from "./landingPage/UserPolicy";
import CookiePolicy from "./landingPage/CookiePolicy";
import AboutUs from "./landingPage/AboutPage";
import ContactUs from "./landingPage/ContactPage";
import AccessibilityPolicy from "./landingPage/AccessibilityPolicy";
import Pricing from "./landingPage/Pricing";
import FAQs from "./landingPage/Faqs";
import CommunityPage from "./commmunity/CommunityPage";
import WalletRedirect from "./components/WalletRedirect";
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const Error = lazy(() => import("./pages/404login"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const PublicPaymentRequest = lazy(() => import("./pages/PublicPaymentRequest"));

function App() {
  const toastOptions = {
    duration: 4000,
    style: {
      background: "#111827",
      color: "#f9fafb",
      fontSize: "0.95rem",
      borderRadius: "0.75rem",
      padding: "1rem",
      boxShadow: "0 10px 30px rgba(15, 23, 42, 0.3)",
    },
    success: {
      iconTheme: {
        primary: "#4ade80",
        secondary: "#0f172a",
      },
    },
    error: {
      iconTheme: {
        primary: "#f87171",
        secondary: "#0f172a",
      },
    },
  };

  return (
    <AuthProvider>
      <CurrencyProvider>
        <PaymentProviderProvider>
          <StripeProvider>
            <Router>
              <AccessibleNavigationAnnouncer />
              <Toaster position="bottom-left" toastOptions={toastOptions} />
          <Suspense fallback={<div>Loading...</div>}>
            <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/home" component={Home} />
            <Route path="/about" component={AboutUs} />
            <Route path="/contact" component={ContactUs} />
            <Route path="/privacy" component={Privacypage} />
            <Route path="/cookies" component={CookiePolicy} />
            <Route path="/pricing" component={Pricing} />
            <Route path="/termsandcondition" component={Terms} />
            <Route path="/user-policy" component={UserPolicy} />
            <Route path="/accessibility" component={AccessibilityPolicy} />
            <Route path="/faqs" component={FAQs} />
            <Route path="/login" component={Login} />
            <Route path="/forgot-password" component={ForgotPassword} />
            <Route path="/reset-password" component={ResetPassword} />
            <Route path="/error" component={Error} />
            <Route path="/register" component={CreateAccount} />
            <Route path="/pay/:publicId" component={PublicPaymentRequest} />
            
            {/* Wallet setup redirect routes */}
            <ProtectedRoute path="/wallet/success" component={WalletRedirect} />
            <ProtectedRoute path="/wallet/collector-success" component={WalletRedirect} />
            <ProtectedRoute path="/wallet/refresh" component={WalletRedirect} />
            
            {/* Rewards shortcut route */}
            <Route path="/rewards">
              <Redirect to="/app/rewards" />
            </Route>

            {/* Place new routes over this */}
            <ProtectedRoute
              path="/app"
              component={Layout}
            />
            <ProtectedRoute path="/community" component={CommunityPage} />
            <Route path="*">
              <Redirect to="/" />
            </Route>
          </Switch>
        </Suspense>
      </Router>
      </StripeProvider>
      </PaymentProviderProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

export default App;
